import React from 'react';
import PropTypes from 'prop-types';

const ComponentSettingsDetails = props => {
  const { renderedMenuItem, items } = props;

  return items.map(item =>
    renderedMenuItem === item.name ? (
      <div key={item.name}>{item.url}</div>
    ) : null
  );
};

ComponentSettingsDetails.propTypes = {
  renderedMenuItem: PropTypes.string,
  items: PropTypes.array,
};

export default ComponentSettingsDetails;
